import ReactGA from "react-ga4";
import { useAppStore } from '@/store';
import { trackEvent } from '@/lib/analytics';

const GA_MEASUREMENT_ID = "G-JC5HTKKRYX";

/**
 * Initializes Google Analytics if the user has consented and a Measurement ID is provided.
 */
export const initGA = () => {
  const { allowAnalytics } = useAppStore.getState();
  if (allowAnalytics && GA_MEASUREMENT_ID) {
    if (!ReactGA.isInitialized) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
    }
  }
};

/**
 * Tracks a page view in Google Analytics.
 * @param path The path of the page to track.
 */
export const trackPageView = (path: string) => {
  const { allowAnalytics } = useAppStore.getState();
  if (allowAnalytics && ReactGA.isInitialized) {
    ReactGA.send({ hitType: "pageview", page: path });
    
    // Also track to Supabase analytics for map visualization
    // This will work for both authenticated and guest users
    trackEvent('page_view', { path });
  }
};

/**
 * Tracks a custom event in Google Analytics.
 * @param category The category of the event.
 * @param action The action of the event.
 * @param label An optional label for the event.
 */
export const trackGAEvent = (category: string, action: string, label?: string) => {
  const { allowAnalytics } = useAppStore.getState();
  if (allowAnalytics && ReactGA.isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};